import React from 'react';
import { Link } from 'react-router-dom';
import ServiceCard from '../../components/ServiceCard';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import ScienceIcon from '@mui/icons-material/Science';
import FavoriteIcon from '@mui/icons-material/Favorite';
import BuildIcon from '@mui/icons-material/Build';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const CATEGORIES = [
  { title: 'Electrosurgical Equipment', desc: 'LEEP equipment, loop electrodes, ball electrodes, ESU units and accessories.', icon: <ElectricBoltIcon />, link: '/shop', category: 'electrosurgical', img: 'https://images.unsplash.com/photo-1551076805-e1869033e561?auto=format&fit=crop&q=80&w=1000' },
  { title: 'Medical Supplies', desc: 'Comprehensive range of consumables, disposables and hospital supplies.', icon: <MedicalServicesIcon />, link: '/shop', category: 'all', img: 'https://images.pexels.com/photos/7722927/pexels-photo-7722927.jpeg?auto=compress&cs=tinysrgb&w=1000' },
  { title: 'Laboratory Equipment', desc: 'PCR tubes, centrifuge tubes, reagents, microbiology and agar media.', icon: <ScienceIcon />, link: '/shop', category: 'lab', img: 'https://images.unsplash.com/photo-1579154204601-01588f351e67?auto=format&fit=crop&q=80&w=1000' },
  { title: 'OB/GYN Instruments', desc: 'Speculums, forceps, cervical dilators, vaginal spatulas and pessaries.', icon: <FavoriteIcon />, link: '/shop', category: 'obgyn', img: 'https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&q=80&w=1000' },
  { title: 'Forceps & Clamps', desc: 'Magill catheter forceps, Debakey clamps, dressing forceps and more.', icon: <BuildIcon />, link: '/shop', category: 'forceps', img: 'https://images.pexels.com/photos/4074689/pexels-photo-4074689.jpeg?auto=compress&cs=tinysrgb&w=1000' },
  { title: 'LeadCare Products', desc: 'LeadCare II analyzers, kits, printers and accessories for blood lead testing.', icon: <AnalyticsIcon />, link: '/shop', category: 'leadcare', img: 'https://images.pexels.com/photos/11333710/pexels-photo-11333710.jpeg?auto=compress&cs=tinysrgb&w=1000' },
];

const HomeCategories: React.FC = () => (
  <section className="py-12 sm:py-20 bg-light">
    <div className="container-main">
      <div className="text-center mb-10 sm:mb-14">
        <span className="section-label">Our Categories</span>
        <h2 className="section-heading mt-2">We Offer a Wide Range of Medical Products</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {CATEGORIES.map(cat => {
          const shopLink = cat.category === 'all' ? '/shop' : `/shop?category=${cat.category}`;
          return (
            <ServiceCard key={cat.title} icon={cat.icon} title={cat.title} description={cat.desc} link={shopLink} backgroundImage={cat.img} />
          );
        })}
      </div>
      <div className="text-center mt-10">
        <Link to="/shop" className="inline-flex items-center gap-2 border-2 border-primary text-primary px-8 py-3 rounded-full font-semibold hover:bg-primary hover:text-white transition-colors">
          View All Products <ArrowForwardIcon />
        </Link>
      </div>
    </div>
  </section>
);

export default HomeCategories;
